// extracted by mini-css-extract-plugin
module.exports = {"topXCard":"TopX_topXCard__Y9kZx","topXCardWl":"TopX_topXCardWl__2R2GS","allSentTextWl":"TopX_allSentTextWl__7Hbdn","sendRequestsBlock":"TopX_sendRequestsBlock__DpumK"};